var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 100,
    width: 100,
    height: 250,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 120,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 120,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 150,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 150,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 150,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 50,
    width: 100,
    height: 300,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 70,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 70,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 70,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 100,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 100,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 100,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 150,
    width: 100,
    height: 200,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 170,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 170,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310,
    y: 170,
    width: 20,
    height: 20,
    fill: "#0059b3",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    fill: "#0059b3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 20,
    r: 15,
    fill: "#0059b3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 25,
    fill: "#0059b3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 70 L180 40",
    stroke: "#0059b3",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215 35 L285 85",
    stroke: "#0059b3",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 30 A20 20 0 0 1 70 50",
    stroke: "#0059b3",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 25 A25 25 0 0 1 75 55",
    stroke: "#0059b3",
    strokeWidth: 2,
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20 A30 30 0 0 1 80 60",
    stroke: "#0059b3",
    strokeWidth: 2,
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIllustration);
export default __webpack_public_path__ + "static/media/about-illustration.0aaadabc6eb6d10f90971037888a53d2.svg";
export { ForwardRef as ReactComponent };